import React from 'react';
import { ArrowUpIcon, ArrowDownIcon, ClockIcon, LinkIcon, AlertCircleIcon } from 'lucide-react';
import { Link } from 'react-router-dom';
const Dashboard = () => {
  // Dummy data for the dashboard
  const stats = [{
    name: 'Total Payments Received',
    value: '$12,456.78',
    change: '+8.1%',
    changeType: 'increase'
  }, {
    name: 'Pending Payments',
    value: '$3,245.90',
    change: '-2.3%',
    changeType: 'decrease'
  }, {
    name: 'Average Payment Time',
    value: '12 days',
    change: '-3.2 days',
    changeType: 'decrease'
  }];
  const upcomingPayments = [{
    id: 1,
    customer: 'ABC Corporation',
    amount: '$1,245.00',
    dueDate: '2023-07-15',
    status: 'Scheduled'
  }, {
    id: 2,
    customer: 'XYZ Industries',
    amount: '$876.50',
    dueDate: '2023-07-18',
    status: 'Pending Approval'
  }, {
    id: 3,
    customer: 'Global Enterprises',
    amount: '$2,340.00',
    dueDate: '2023-07-22',
    status: 'Scheduled'
  }];
  const recentActivity = [{
    id: 1,
    type: 'payment',
    customer: 'Tech Solutions Inc.',
    amount: '$945.00',
    date: '2023-07-10',
    status: 'Completed'
  }, {
    id: 2,
    type: 'invoice',
    customer: 'Innovate Ltd.',
    amount: '$1,876.50',
    date: '2023-07-08',
    status: 'Received'
  }, {
    id: 3,
    type: 'bank',
    description: 'New bank account verified',
    date: '2023-07-05',
    status: 'Completed'
  }, {
    id: 4,
    type: 'promo',
    description: 'Created 10% early payment discount',
    date: '2023-07-01',
    status: 'Active'
  }];
  return <div className="space-y-6" data-id="element-295">
      <div className="flex flex-col md:flex-row justify-between items-start md:items-center" data-id="element-296">
        <div data-id="element-297">
          <h1 className="text-2xl font-bold text-gray-900" data-id="element-298">Dashboard</h1>
          <p className="mt-1 text-sm text-gray-500" data-id="element-299">
            Welcome back to your supplier dashboard
          </p>
        </div>
        <div className="mt-4 md:mt-0 flex space-x-3" data-id="element-300">
          <button className="inline-flex items-center px-4 py-2 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500" data-id="element-301">
            <LinkIcon className="h-4 w-4 mr-2" data-id="element-302" />
            Connect Accounting
          </button>
        </div>
      </div>
      {/* Stats */}
      <div className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3" data-id="element-303">
        {stats.map(stat => <div key={stat.name} className="bg-white overflow-hidden shadow rounded-lg" data-id="element-304">
            <div className="px-4 py-5 sm:p-6" data-id="element-305">
              <div className="flex items-center" data-id="element-306">
                <div className="flex-shrink-0 rounded-md p-3 bg-blue-50" data-id="element-307">
                  {stat.name.includes('Received') ? <ArrowDownIcon className="h-6 w-6 text-blue-600" data-id="element-308" /> : stat.name.includes('Pending') ? <ClockIcon className="h-6 w-6 text-blue-600" data-id="element-309" /> : <ArrowUpIcon className="h-6 w-6 text-blue-600" data-id="element-310" />}
                </div>
                <div className="ml-5 w-0 flex-1" data-id="element-311">
                  <dl data-id="element-312">
                    <dt className="text-sm font-medium text-gray-500 truncate" data-id="element-313">
                      {stat.name}
                    </dt>
                    <dd data-id="element-314">
                      <div className="text-lg font-medium text-gray-900" data-id="element-315">
                        {stat.value}
                      </div>
                    </dd>
                  </dl>
                </div>
              </div>
              <div className="mt-4" data-id="element-316">
                <div className={`inline-flex items-baseline px-2.5 py-0.5 rounded-full text-sm font-medium ${stat.changeType === 'increase' ? 'bg-green-100 text-green-800' : 'bg-red-100 text-red-800'}`} data-id="element-317">
                  {stat.changeType === 'increase' ? <ArrowUpIcon className="-ml-1 mr-0.5 flex-shrink-0 self-center h-4 w-4 text-green-500" data-id="element-318" /> : <ArrowDownIcon className="-ml-1 mr-0.5 flex-shrink-0 self-center h-4 w-4 text-red-500" data-id="element-319" />}
                  <span className="sr-only" data-id="element-320">
                    {stat.changeType === 'increase' ? 'Increased' : 'Decreased'}{' '}
                    by
                  </span>
                  {stat.change}
                </div>
                <span className="text-sm text-gray-500 ml-2" data-id="element-321">
                  from last month
                </span>
              </div>
            </div>
          </div>)}
      </div>
    </div>;
};
export default Dashboard;